module.exports = __webpack_public_path__ + "img/searchengin.076ef8d2.svg";